import * as Sentry from "@sentry/browser";
import createSentryMiddleware from "redux-sentry-middleware";

Sentry.init({
  debug: process.env.NODE_ENV === "development",
  enabled: process.env.NODE_ENV === "production",
  release: process.env.REACT_APP_SENTRY_RELEASE,
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
});

export const sentryMiddleware = createSentryMiddleware(Sentry);

export default Sentry;
